import { render } from "./Advice2.vue?vue&type=template&id=4d649bb9&scoped=true"
import script from "./Advice2.vue?vue&type=script&lang=js"
export * from "./Advice2.vue?vue&type=script&lang=js"

import "./Advice2.vue?vue&type=style&index=0&id=4d649bb9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d649bb9"]])

export default __exports__